<template>
  <modal :show="show" :max-width="maxWidth" :closeable="closeable" @close="close">
    <div class="relative px-6 py-4">
      <h3 class="text-lg font-bold">
        {{ $t('Application Alerts') }}
      </h3>
      <button
        @click="close()"
        class="fixed top-2 right-2 flex items-center justify-center h-8 w-8 rounded-full text-gray-600 hover:text-gray-800 hover:bg-gray-300 focus:outline-none"
      >
        <icons name="cross" class="h-5 w-5" />
      </button>

      <div class="mt-4">
        <section class="py-2 mx-auto max-w-7xl">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div class="p-4 border rounded-md">
              <div class="flex items-start justify-between">
                <h2 class="mb-2 text-xl font-semibold leading-none text-gray-900 truncate">23,455</h2>
                <span class="flex items-center space-x-1 text-sm font-medium leading-none text-green-600">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="flex-none w-4 h-4">
                    <path
                      fill-rule="evenodd"
                      d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span>40%</span>
                </span>
              </div>
              <p class="text-sm leading-none text-gray-600">Posts</p>
            </div>
            <div class="p-4 border rounded-md">
              <div class="flex items-start justify-between">
                <h2 class="mb-2 text-xl font-semibold leading-none text-gray-900 truncate">55</h2>
                <span class="flex items-center space-x-1 text-sm font-medium leading-none text-green-600">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="flex-none w-4 h-4">
                    <path
                      fill-rule="evenodd"
                      d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span>240%</span>
                </span>
              </div>
              <p class="text-sm leading-none text-gray-600">Comments</p>
            </div>
            <div class="p-4 border rounded-md">
              <div class="flex items-start justify-between">
                <h2 class="mb-2 text-xl font-semibold leading-none text-gray-900 truncate">129,752</h2>
                <span class="flex items-center space-x-1 text-sm font-medium leading-none text-red-600">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="flex-none w-4 h-4">
                    <path
                      fill-rule="evenodd"
                      d="M12 13a1 1 0 100 2h5a1 1 0 001-1V9a1 1 0 10-2 0v2.586l-4.293-4.293a1 1 0 00-1.414 0L8 9.586 3.707 5.293a1 1 0 00-1.414 1.414l5 5a1 1 0 001.414 0L11 9.414 14.586 13H12z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span>22%</span>
                </span>
              </div>
              <p class="text-sm leading-none text-gray-600">Activities</p>
            </div>
            <div class="p-4 border rounded-md">
              <div class="flex items-start justify-between">
                <h2 class="mb-2 text-xl font-semibold leading-none text-gray-900 truncate">1,255</h2>
                <span class="flex items-center space-x-1 text-sm font-medium leading-none text-green-600">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="flex-none w-4 h-4">
                    <path
                      fill-rule="evenodd"
                      d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span>10%</span>
                </span>
              </div>
              <p class="text-sm leading-none text-gray-600">Users</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/Jetstream/Modal';

export default {
  emits: ['close'],

  components: { Modal },

  props: {
    show: {
      default: false,
    },
    maxWidth: {
      default: '2xl',
    },
    closeable: {
      default: true,
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
